import React, { useEffect, useState } from 'react';
import {
  View,
  Modal,
  ModalProps,
  useWindowDimensions,
  Platform
} from 'react-native';
import * as LocalAuthentication from 'expo-local-authentication';
import { Ionicons, Feather } from '@expo/vector-icons';
import styled from 'styled-components/native';

import IconButton from '../../../components/IconButton';
import Colors from '../../../constants/Colors';
import Button from '../../../components/Button';
import { H5, Subtitle } from '../../../components/Typography';
import biometrics from '../../../biometrics/biometrics';
import Spacer from '../../../components/Spacer';

const StyledDimContainer = styled.View`
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  align-items: center;
  justify-content: center;
`;

const StyledDialog = styled.View<{ isMobile: boolean }>`
  width: ${p => (p.isMobile ? 100 : 90)}%;
  height: ${p => (p.isMobile ? 100 : 90)}%;
  border-radius: 10px;
  max-width: 1080px;
  max-height: ${p => (p.isMobile ? '100%' : '627px')};
  overflow: hidden;
  background-color: ${Colors.background};
`;

const StyledContainer = styled.View`
  flex: 1;
  margin-top: ${Platform.OS === 'ios' ? 48 : 20}px;
`;

const StyledIconButton = styled(IconButton)`
  position: absolute;
  left: 10px;
`;

const StyledHeaderTextContainer = styled.View`
  align-self: center;
`;

const StyledView = styled.View`
  flex: 1;
  justify-content: center;
  align-items: center;
`;

const StyledMessageContainer = styled.View`
  width: 100%;
  max-width: 340px;
`;

const StyledImage = styled.Image`
  margin-top: -30px;
  margin-bottom: 30px;
  align-self: center;
  max-width: 150px;
  tint-color: black;
`;

const StyledMessageTextContainer = styled.View`
  margin-horizontal: 40px;
`;

const EnableBiometricsModal: React.FC<ModalProps> = ({ ...props }) => {
  const [biometricTypes, setBiometricTypes] = useState([1]);
  const { onRequestClose } = props;
  const window = useWindowDimensions();
  const isMobile = window.width < 468;
  const checkBiometricType = async () => {
    const supportedBiometricTypes =
      await LocalAuthentication.supportedAuthenticationTypesAsync();
    setBiometricTypes(supportedBiometricTypes);
  };

  useEffect(() => {
    checkBiometricType();
  }, []);

  let title = 'Enable Face ID';
  let message = 'Do you want to enable Face ID?';
  if (biometricTypes.length >= 2) {
    title = 'Enable Biometrics';
    message = 'Do you want to enable Biometrics?';
  } else if (
    biometricTypes[0] === LocalAuthentication.AuthenticationType.FINGERPRINT
  ) {
    if (Platform.OS === 'android') {
      title = 'Enable Fingerprint';
      message = 'Do you want to enable Fingerprint?';
    } else {
      title = 'Enable Touch ID?';
      message = 'Do you want to enable Touch ID?';
    }
  }
  return (
    <Modal animationType='fade' transparent>
      <StyledDimContainer>
        <StyledDialog isMobile={isMobile}>
          <StyledContainer>
            <View>
              <StyledIconButton onPress={onRequestClose}>
                <Feather name='chevron-left' size={25} color='black' />
              </StyledIconButton>
              <StyledHeaderTextContainer>
                <Subtitle color='dark'>{title}</Subtitle>
              </StyledHeaderTextContainer>
            </View>
            <StyledView>
              <StyledMessageContainer>
                <StyledImage
                  resizeMode='contain'
                  source={
                    biometricTypes[0] === 1
                      ? require(`../../../assets/sign-up/fingerprint.png`)
                      : require(`../../../assets/sign-up/face-id.png`)
                  }
                />
                <StyledMessageTextContainer>
                  <H5 color='dark' padding={5} center>
                    {message}
                  </H5>
                </StyledMessageTextContainer>
                <Button
                  startIcon={
                    <Ionicons
                      name='lock-closed'
                      size={20}
                      color={Colors.primaryText}
                    />
                  }
                  onPress={event => {
                    biometrics.setBiometricLogin(true);
                    onRequestClose?.(event);
                  }}
                >
                  Yes
                </Button>
                <Spacer size={2} />
                <Button outlined onPress={event => onRequestClose?.(event)}>
                  No
                </Button>
              </StyledMessageContainer>
            </StyledView>
          </StyledContainer>
        </StyledDialog>
      </StyledDimContainer>
    </Modal>
  );
};

export default EnableBiometricsModal;
